import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Brand, ThemeToggle } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(name, email, password);
      nav("/host");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="flex items-center justify-between p-5">
        <Brand onClick={() => nav("/")} />
        <ThemeToggle />
      </header>
      <div className="mx-auto flex max-w-md flex-col px-6 pt-10">
        <h1 className="font-heading text-4xl font-extrabold tracking-tight">Host a tournament</h1>
        <p className="mt-2 text-muted-foreground">Create a free host account to get started.</p>
        <Card className="mt-8 p-6">
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="name">Your name</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)}
                required data-testid="register-name-input" className="mt-1.5" placeholder="Alex Organizer" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required data-testid="register-email-input" className="mt-1.5" placeholder="you@example.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required data-testid="register-password-input" className="mt-1.5" placeholder="Choose a password" />
            </div>
            {error && <p className="text-sm font-medium text-destructive" data-testid="register-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="register-submit-button">
              {loading ? "Creating…" : "Create account"}
            </Button>
          </form>
          <p className="mt-5 text-center text-sm text-muted-foreground">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-primary" data-testid="register-login-link">Sign in</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
